import * as React from 'react';
import { Icon } from 'antd';

const ChatSvgV2 = props => (
  <svg fill="none" {...props} width="18" height="18" viewBox="0 0 20 20">
    <style>
      {`
        .chat-dots {
          animation: bounce 1.5s infinite;
        }
        .chat-dot-1 {
          animation-delay: 0s;
        }
        .chat-dot-2 {
          animation-delay: 0.2s;
        }
        .chat-dot-3 {
          animation-delay: 0.4s;
        }
        @keyframes bounce {
          0%, 60%, 100% {
            transform: translateY(0);
            opacity: 1;
          }
          30% {
            transform: translateY(-1.2px);
            opacity: 0.7;
          }
        }
      `}
    </style>
    <path
      d="M17.5 2.5H2.5C1.12 2.5 0 3.62 0 5V12.5C0 13.88 1.12 15 2.5 15H5V18.125C5 18.62 5.575 18.898 5.978 18.589L10.625 15H17.5C18.88 15 20 13.88 20 12.5V5C20 3.62 18.88 2.5 17.5 2.5Z"
      fill="#1751D0"
    />
    <circle className="chat-dots chat-dot-1" cx="6.25" cy="8.75" r="1.06" fill="white" />
    <circle className="chat-dots chat-dot-2" cx="10" cy="8.75" r="1.06" fill="white" />
    <circle className="chat-dots chat-dot-3" cx="13.75" cy="8.75" r="1.06" fill="white" />
  </svg>
);

const ChatIconComponent = props => <ChatSvgV2 {...props} />;

const ChatIconV2 = props => <Icon component={ChatIconComponent} {...props} />;

export default ChatIconV2;
